module.exports = __webpack_public_path__ + "static/media/line-throught.8c982310.svg";